import { get, post, put, deleted } from '..';
import routes from './routes';

const ProductServices = {
  createProduct: async (obj) => {
    const data = await post(routes.createProduct, obj);
    return data;
  },
  getProducts: async (params) => {
    const data = await get(routes.getProducts, params);
    return data;
  },
  getProductById: async (id) => {
    const data = await get(routes.getProductById + id);
    return data;
  },
  updateProduct: async (id, obj) => {
    const data = await put(routes.updateProduct + id, obj);
    return data;
  },
  deleteProduct: async (id) => {
    const data = await deleted(routes.deleteProduct + id);
    return data;
  },
  addInventory: async (obj) => {
    const data = await post(routes.addInventory, obj);
    return data;
  },
  inventoryAdjustment: async (obj) => {
    const data = await post(routes.inventoryAdjustment, obj);
    return data;
  },
  updateVariants: async (id, obj) => {
    const data = await put(routes.updateVariants + id + '/variant', obj);
    return data;
  },
  deleteVariant: async (id) => {
    const data = await deleted(routes.deleteVariant + id);
    return data;
  },
}

export default ProductServices